import React, {useEffect, useRef, useState} from 'react';
import TopBar from "./Components/TopBar/TopBar";
import "./LandingPage.css"
import {Button} from "@mui/material";
import Box from "@mui/material/Box";
import ProfileImage from "./../Images/Profil-1.jpg"
import PrimaryButton from "./Components/Buttons/PrimaryButton";
import FrontPage from "./FrontPage/FrontPage";
import AboutMePage from "./AboutMe/AboutMePage";
import CustomerPage from "./CustomerPage/CustomerPage";
import LandingPageContainer from "./Components/LandingPageContainer/LandingPageContainer";
import Background from "./Background";
import CoachingPage from "./CoachingPage/CoachingPage";
import CoachingAppointment from "./CoachingAppointment/CoachingAppointment";
import ShopSection from "./ShopSection/ShopSection";
import DigitalHub from "./DigitalHub/DigitalHub";
import CostComponent from "./CostCustomerPage/CostComponent";
import PackagesSection from "./ShopSection/PackagesSection";
import ShortLandingPageContainer from "./Components/LandingPageContainer/ShortLandingPageContainer";
import Footer from "./Footer";

function LandingPage(props) {
    const about_me_ref = useRef(null)
    const reviews_ref = useRef(null)
    const spp_expect_ref = useRef(null)
    const spp_digi_hub_ref = useRef(null)
    const cost_ref = useRef(null)
    const talk_ref = useRef(null)
    const single_ref = useRef(null)
    const multi_ref = useRef(null)

    const [heightFirst, setHeightFirst] = useState(0)
    const [heightSecond, setHeightSecond] = useState(0)
    const [heightThird, setHeightThird] = useState(0)

    const refFrontPage = useRef(null)
    const refAboutMe = useRef(null)
    const refCustomerPage = useRef(null)
    const refCoaching = useRef(null)
    const refDigitalHub = useRef(null)
    const refCostComponent = useRef(null)
    const refAppointment = useRef(null)
    const landingPageRef = useRef(null);

    const [visibleButtons, setVisibleButtons] = useState(true)

    const handleResize = () => {
        console.log("rendering")
        if(refFrontPage.current == null){return}
        let first =
            refFrontPage.current.clientHeight +
            refAboutMe.current.clientHeight +
            refCustomerPage.current.clientHeight;


        let second =
            refFrontPage.current.clientHeight +
            refAboutMe.current.clientHeight +
            refCustomerPage.current.clientHeight +
            refCoaching.current.clientHeight;

        let third =
            refFrontPage.current.clientHeight +
            refAboutMe.current.clientHeight +
            refCustomerPage.current.clientHeight +
            refCoaching.current.clientHeight +
            refDigitalHub.current.clientHeight +
            refCostComponent.current.clientHeight +
            refAppointment.current.clientHeight;

        setHeightFirst(first);
        setHeightSecond(second);
        setHeightThird(third);

    }
    useEffect(() => {
        if (!landingPageRef.current) return;

        const observer = new ResizeObserver(() => {
            handleResize();
        });

        observer.observe(landingPageRef.current);

        // Call it once initially
        handleResize();

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <TopBar className="top-bar"
                    refs={[about_me_ref, reviews_ref, spp_expect_ref, spp_digi_hub_ref, cost_ref, talk_ref, single_ref, multi_ref]}/>

            <Box
                ref={landingPageRef}
                sx={{display: "flex", width: "100%", flexDirection: "column", zIndex: -1}}
                 onTouchMove={() => setVisibleButtons(true)} onTouchEnd={() => setVisibleButtons(false)}>

                <Background heights={[heightFirst,heightSecond,heightThird]}/>

                <Box sx={{
                    maxWidth: "1440px",
                    width: '100%',
                    overflow: "hidden",
                    alignSelf: "center",
                    zIndex: 1
                }}>
                    <Box sx={{
                        height: "40px",
                        width: "100%"
                    }}></Box>
                    <FrontPage ref={refFrontPage} talk_ref={talk_ref} refs={cost_ref}/>
                    <LandingPageContainer ref={refAboutMe}>
                        <AboutMePage refs={about_me_ref}/>
                    </LandingPageContainer>
                    <LandingPageContainer ref={refCustomerPage}>
                        <CustomerPage refs={reviews_ref} visibleButtons={visibleButtons}/>
                    </LandingPageContainer>
                    <LandingPageContainer ref={refCoaching}>
                        <CoachingPage refs={spp_expect_ref}/>
                    </LandingPageContainer>
                    <ShortLandingPageContainer ref={refDigitalHub}>
                        <DigitalHub refs={spp_digi_hub_ref}/>
                    </ShortLandingPageContainer>
                    <ShortLandingPageContainer ref={refCostComponent}>
                        <CostComponent refs={cost_ref} talk_ref={talk_ref}/>
                    </ShortLandingPageContainer>
                    <ShortLandingPageContainer ref={refAppointment}>
                        <CoachingAppointment refs={talk_ref}/>
                    </ShortLandingPageContainer>
                    <LandingPageContainer>
                        <ShopSection refs={single_ref}/>
                    </LandingPageContainer>
                    <LandingPageContainer>
                        <PackagesSection refs={multi_ref}/>
                    </LandingPageContainer>
                </Box>
                <Footer/>

            </Box>
        </>
    );
}

export default LandingPage;